var swiper = new Swiper(".thumbnail--inner", {
  loop: true,
  spaceBetween: 10,
  slidesPerView: 4,
  centeredSlides: false,

  breakpoints: {
    640: {
      slidesPerView: 11,
      spaceBetween: 10,
      centeredSlides: true,
    }
  },
});
var swiper2 = new Swiper(".product__gallery", {
  loop: true,
  spaceBetween: 10,
  thumbs: {
    swiper: swiper,
  },
});